<script setup lang="ts">
const error = useError();
const { clear } = useAuth();

const handleBackToHome = () => {
  clear();
  clearError();
  window.location.href = 'https://abonne-moi.com';
};

const errorMessage = computed(() => {
  switch (error.value?.statusCode) {
    case 404:
      return "Cette page n'existe pas";
    case 401:
      return "Vous n'êtes pas autorisé à accéder à cette page";
    case 403:
      return "Accès refusé";
    case 500:
      return "Une erreur serveur est survenue";
    default:
      return "Une erreur inattendue est survenue";
  }
});
</script>

<template>
  <div class="min-h-screen bg-gray-50 flex items-center justify-center px-4">
    <div class="max-w-lg w-full text-center">
      <!-- Logo -->
      <img
        src="/public/logo.svg"
        alt="Abonne-moi Logo"
        class="h-16 w-auto mx-auto mb-8"
      />

      <!-- Error Information -->
      <div class="bg-white rounded-lg shadow-lg p-8">
        <div class="mb-6">
          <h1 class="text-4xl font-bold text-gray-900 mb-2">
            {{ error?.statusCode || '500' }}
          </h1>
          <p class="text-lg text-gray-600">
            {{ errorMessage }}
          </p>
          <p
            v-if="error?.message"
            class="mt-2 text-sm text-gray-500">
            {{ error.message }}
          </p>
        </div>

        <!-- Actions -->
        <div class="space-y-4">
          <UButton
            block
            color="primary"
            @click="handleBackToHome"
          >
            Retourner à l'accueil
          </UButton>

          <div class="text-sm text-gray-500">
            <p>Besoin d'aide ? Contactez-nous :</p>
            <a
              href="mailto:contact@abonne-moi.com"
              class="text-primary hover:text-primary-600 transition-colors"
            >
              contact@abonne-moi.com
            </a>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="mt-8 text-sm text-gray-500">
        <p>© {{ new Date().getFullYear() }} Abonne-moi. Tous droits réservés.</p>
      </div>
    </div>

    <!-- Decorative Elements -->
    <div class="pointer-events-none absolute inset-0 overflow-hidden">
      <div class="bg-primary/20 animate-blob absolute -right-10 -top-10 h-48 w-48 rounded-full blur-3xl" />
      <div class="bg-primary/20 animate-blob animation-delay-2000 absolute -bottom-10 -left-10 h-48 w-48 rounded-full blur-3xl" />
    </div>
  </div>
</template>

<style scoped>
@keyframes blob {
  0% {
    transform: translate(0px, 0px) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
  100% {
    transform: translate(0px, 0px) scale(1);
  }
}

.animate-blob {
  animation: blob 7s infinite;
}

.animation-delay-2000 {
  animation-delay: 2s;
}
</style>
